import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { InterLinksImportFormFields } from '../helpers/types';

const useInterLinkFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    [InterLinksImportFormFields.FILE]: [requiredRule],
  };
};

export default useInterLinkFormRules;
